module.exports = __webpack_public_path__ + "img/friend1.ff35ccae.png";